<div class="input-grid-gaps grid-6col container">
    @if (!readiness?.suklCertificate) {
        <h4 class="fr-6">{{ 'ePrescriptions.checkReadiness.suklCertificate' | translate }}</h4>
        <app-service-upload-certificate class="fr-6" [serviceId]="store.folder()?.serviceId || 0"></app-service-upload-certificate>
    }

    @if (!readiness?.userQualifiedCertificate) {
        <h4 class="fr-6">{{ 'ePrescriptions.checkReadiness.qualifiedCertificate' | translate }}</h4>
        <i class="fr-6">{{ 'ePrescriptions.checkReadiness.qualifiedCertificateSub' | translate }}</i>
        <app-user-upload-certificate [userId]="store.currentUser()?.id || null" class="fr-6"></app-user-upload-certificate>
    }

    @if (!readiness?.userSuklIdentity) {
        <h4 class="fr-6">{{ 'ePrescriptions.checkReadiness.suklIdentity' | translate }}</h4>
        <i class="fr-6">{{ 'ePrescriptions.checkReadiness.suklIdentitySub' | translate }}</i>
        <app-user-upload-secret [userId]="store.currentUser()?.id || null" class="fr-6"></app-user-upload-secret>
    }

    @if (!readiness?.servicePzs) {
        <h4 class="fr-6">{{ 'ePrescriptions.checkReadiness.pzs' | translate }}</h4>
        <i class="fr-6">{{ 'ePrescriptions.checkReadiness.pzsSub' | translate }}</i>
        <div class="fr-3">
            <app-link-button [label]="'ePrescriptions.checkReadiness.pzsLink' | translate" (clickEvent)="navigateToPZS()"></app-link-button>
        </div>
    }

    @if (!readiness?.userIcp) {
        <h4 class="fr-6">{{ 'ePrescriptions.checkReadiness.icp' | translate }}</h4>
        <div class="fr-3">
            <app-link-button [label]="'ePrescriptions.checkReadiness.icpLink' | translate" (clickEvent)="navigateToUserProfile()"></app-link-button>
        </div>
    }

    @if (!readiness?.userPhone) {
        <h4 class="fr-6">{{ 'ePrescriptions.checkReadiness.userPhone' | translate }}</h4>
        <div class="fr-3">
            <app-link-button [label]="'ePrescriptions.checkReadiness.icpLink' | translate" (clickEvent)="navigateToUserProfile()"></app-link-button>
        </div>
    }
</div>
